import { Midi } from "@tonejs/midi";

export const SAMPLE = {
  header: {
    tempos: [
      {
        bpm: 150,
        ticks: 0,
        time: 0,
      },
    ],
    timeSignatures: [],
    keySignatures: [],
    meta: [],
    name: "",
  },
  tracks: [
    {
      name: "",
      notes: [
        {
          midi: 48,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 384,
          durationTicks: 8576,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 384,
          durationTicks: 256,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 640,
          durationTicks: 256,
        },
        {
          midi: 79,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 896,
          durationTicks: 256,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 1152,
          durationTicks: 256,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 1408,
          durationTicks: 256,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 1664,
          durationTicks: 128,
        },
        {
          midi: 79,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 1792,
          durationTicks: 384,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 2176,
          durationTicks: 512,
        },
        {
          midi: 69,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 2432,
          durationTicks: 1024,
        },
        {
          midi: 45,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 2432,
          durationTicks: 2048,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 2688,
          durationTicks: 256,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 2944,
          durationTicks: 256,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 3200,
          durationTicks: 512,
        },
        {
          midi: 69,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 3456,
          durationTicks: 1024,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 3712,
          durationTicks: 128,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 3840,
          durationTicks: 384,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 4224,
          durationTicks: 768,
        },
        {
          midi: 43,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 4480,
          durationTicks: 2176,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 4480,
          durationTicks: 256,
        },
        {
          midi: 71,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 4736,
          durationTicks: 512,
        },
        {
          midi: 74,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 4992,
          durationTicks: 1024,
        },
        {
          midi: 71,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 5248,
          durationTicks: 128,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 5376,
          durationTicks: 384,
        },
        {
          midi: 71,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 5760,
          durationTicks: 512,
        },
        {
          midi: 74,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 6016,
          durationTicks: 5248,
        },
        {
          midi: 71,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 6272,
          durationTicks: 384,
        },
        {
          midi: 43,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 6656,
          durationTicks: 8576,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 6656,
          durationTicks: 256,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 6912,
          durationTicks: 128,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 7040,
          durationTicks: 256,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 7296,
          durationTicks: 128,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 7424,
          durationTicks: 256,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 7680,
          durationTicks: 256,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 7936,
          durationTicks: 256,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 8192,
          durationTicks: 256,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 8448,
          durationTicks: 128,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 8576,
          durationTicks: 6656,
        },
        {
          midi: 48,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 8960,
          durationTicks: 12672,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 8960,
          durationTicks: 256,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 9216,
          durationTicks: 256,
        },
        {
          midi: 79,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 9472,
          durationTicks: 256,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 9728,
          durationTicks: 128,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 9856,
          durationTicks: 384,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 10240,
          durationTicks: 256,
        },
        {
          midi: 79,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 10496,
          durationTicks: 256,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 10752,
          durationTicks: 512,
        },
        {
          midi: 47,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 11008,
          durationTicks: 2048,
        },
        {
          midi: 71,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 11008,
          durationTicks: 896,
        },
        {
          midi: 74,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 11264,
          durationTicks: 256,
        },
        {
          midi: 77,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 11520,
          durationTicks: 256,
        },
        {
          midi: 74,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 11776,
          durationTicks: 512,
        },
        {
          midi: 71,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 11904,
          durationTicks: 1152,
        },
        {
          midi: 74,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 12288,
          durationTicks: 256,
        },
        {
          midi: 77,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 12544,
          durationTicks: 256,
        },
        {
          midi: 74,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 12800,
          durationTicks: 512,
        },
        {
          midi: 69,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 13056,
          durationTicks: 1024,
        },
        {
          midi: 45,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 13056,
          durationTicks: 2176,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 13312,
          durationTicks: 128,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 13440,
          durationTicks: 384,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 13824,
          durationTicks: 512,
        },
        {
          midi: 69,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 14080,
          durationTicks: 1152,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 14336,
          durationTicks: 128,
        },
        {
          midi: 76,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 14464,
          durationTicks: 384,
        },
        {
          midi: 72,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 14848,
          durationTicks: 12672,
        },
        {
          midi: 67,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 15232,
          durationTicks: 12672,
        },
        {
          midi: 43,
          velocity: 1,
          noteOffVelocity: 0,
          ticks: 15232,
          durationTicks: 12672,
        },
      ],
      controlChanges: {
        "123": [
          {
            ticks: 28048,
            value: 0,
          },
        ],
      },
      pitchBends: [],
      instrument: {
        number: 1,
      },
      channel: 0,
      endOfTrackTicks: 28048,
    },
  ],
} as unknown as Midi;
